// extracted by mini-css-extract-plugin
export default {"open-in-new-tab":"eL0oPRx21kY76KW2OzZ0UUEHeApG61covFl0-DyZzh8="};